import { Signal } from "signals";
import CanvasManager from "slotworks/graphics/canvas/canvas-manager";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";

export default class SliderElement {

    public onChange: Signal;
    public onInput: Signal;

    private value: number;
    private percent: number;
    private dragging: boolean;
    private trackWidth: number;

    private min: number;
    private max: number;
    private step: number;

    private track: PIXI.Sprite;
    private fill: PIXI.Sprite;
    private handle: PIXI.Sprite;

    private mask: PIXI.Graphics;

    private enabled: boolean;

    constructor(track: PIXI.Sprite, fill: PIXI.Sprite, min: number, max: number, step: number, handle?: PIXI.Sprite) {
        this.onChange = new Signal();
        this.onInput = new Signal();

        this.setEnabled(true);

        this.track = track;
        this.fill = fill;

        this.mask = new PIXI.Graphics();
        this.mask.x = this.fill.x;
        this.mask.y = this.fill.y;
        this.mask.drawRect(0, 0, this.fill.getBounds().width, this.fill.getBounds().height);

        this.fill.mask = this.mask;
        this.fill.parent.addChild(this.mask);

        this.min = min;
        this.max = max;
        this.step = step;
        this.value = this.min;
        this.percent = 0;
        this.trackWidth = this.track.getBounds().width;

        if (handle) {
            this.handle = handle;
            this.handle.anchor.set(0.5, 0);
            this.handle.interactive = true;
            this.handle.buttonMode = true;
            this.handle.on(ButtonEvent.POINTER_DOWN.getEventString() as any, this.startDrag);
            this.handle.on(ButtonEvent.POINTER_UP.getEventString() as any, this.stopDrag);
            this.handle.on(ButtonEvent.POINTER_UP_OUTSIDE.getEventString() as any, this.stopDrag);
            this.handle.on(ButtonEvent.POINTER_MOVE.getEventString() as any, this.drag);
        }
    }

    public destroy() {
        this.onInput.removeAll();
        this.onChange.removeAll();
    }

    public setValue(value: number) {
        this.percent = (value - this.min) / (this.max - this.min);

        this.percent = Math.min(1, Math.max(0, this.percent));

        this.update();
    }

    public setMin(value: number) {
        this.min = value;
    }

    public setMax(value: number) {
        this.max = value;
    }

    public setVisible(visible: boolean) {
        this.track.visible = visible;
        this.fill.visible = visible;
        this.handle.visible = visible;
    }

    public setEnabled(enabled: boolean) {
        this.enabled = enabled;
    }

    private update() {
        this.value = Math.round((this.min + (this.max - this.min) * this.percent) / this.step) * this.step;
        const snappedPercent = (this.value - this.min) / (this.max - this.min);

        this.mask.scale.x = snappedPercent;
        this.handle.x = this.track.x + snappedPercent * this.trackWidth;
    }

    private startDrag = () => {
        this.dragging = true;
    }

    private stopDrag = () => {
        if (this.dragging) {
            this.dragging = false;
            this.onChange.dispatch(this.value);
        }
    }

    private drag = () => {
        if (this.enabled) {
            if (this.dragging) {
                const localMouse = Layers.MenusContent.globalToLocal(CanvasManager.renderer.plugins.interaction.mouse.global);
                const positionInBar = Math.max(0, Math.min(this.trackWidth, localMouse.x - this.track.x));
                this.percent = positionInBar / this.trackWidth;

                this.update();
                this.onInput.dispatch(this.value);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/graphics/elements/slider-element.ts